import React from 'react';

import { weekdays } from '@/core/features/date/date';

type DatePickerVerticalHeaderProps = {
    hasNoSpacing?: boolean;
    hasStickyHeader?: boolean;
    headerBackgroundColor?: string;
    headerSlot?: React.ReactElement;
    headerTextColor?: string;
};

export default function DatePickerVerticalHeader({
    hasNoSpacing = false,
    hasStickyHeader = false,
    headerBackgroundColor: backgroundColor,
    headerSlot,
    headerTextColor: color,
}: DatePickerVerticalHeaderProps) {
    return (
        <div
            className={`width-100 top-0 ${hasStickyHeader ? 'sticky z-index-2' : ''}`}
            style={{
                backgroundColor,
                color,
            }}
        >
            {headerSlot}
            <div
                className={`flex align-end margin-left-10 margin-right-10 ${hasNoSpacing ? 'margin-top-0 padding-0' : 'padding-top-10 padding-bottom-10'}`}
                style={{
                    marginTop: hasNoSpacing ? 0 : 7,
                }}
            >
                {weekdays.map((weekday, index) => (
                    <div
                        className={'flex justify-center'}
                        key={`${weekday}-${index}`}
                        style={{
                            // eslint-disable-next-line no-inline-styles/no-inline-styles
                            flex: '1 1 0',
                        }}
                    >
                        {weekday}
                    </div>
                ))}
            </div>
        </div>
    );
}
